export default __webpack_public_path__ + "static/media/Warhaven.8405d2c0.jpg";